<template>
  <div class="overflow-hidden px-4">
      <!-- Alert message -->
   <div>
     <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{alert_message}}</v-alert>
   </div>
   <!-- Header component -->
   <div> <HeaderComponent :headerTitle="headerText" :routerLink="getRouterLink()" :routerLinkText="router_text" :componentName="compo_name"/></div>
   <loading :active.sync="isLoading" 
       :can-cancel="true" 
       :is-full-page="fullPage" :color="primary_code"></loading>
   <!-- Tabs -->
    <v-tabs>
         <v-tab @click="loadData(tab, 'tab_clicked')" style="text-transform:none" v-for="(tab, index) in tabs" :key="`${tab+index}`">{{tab}}</v-tab>
    </v-tabs>
    <div v-if="!(active_tab === 'User Feedback' || active_tab === 'Uploaded Documents' || active_tab === 'Approval History')">
     <v-card class="px-3 mt-3" style="background: #F3F3F3;" v-if="!(active_tab === 'Uploaded Documents' || active_tab === 'Approval History')">
       <v-row class="py-5">
         <v-col cols="1" class="py-0 right_border">
           <p class="card_heading">Lot ID</p>
           <p class="card_value" v-if="active_tab === 'Bid Details' || active_tab === 'User Feedback'">{{ lot_details && lot_details.lot_id ? lot_details.lot_id : '-' }}</p>
           <p class="card_value" v-else>{{ lot_details && lot_details.id ? lot_details.id : '-' }}</p>
         </v-col>
         <v-col cols="3" class="py-0 right_border">
           <p class="card_heading">Lot Name</p>
           <p class="card_value">{{ lot_details && lot_details.lot_name ? lot_details.lot_name : '-' }}</p>
         </v-col>
         <v-col cols="2" class="py-0 right_border">
           <p class="card_heading">Lot Type</p>
           <p class="card_value">{{ lot_details && lot_details.lot_type ? lot_details.lot_type : '-' }}</p>
         </v-col>
         <v-col cols="2" class="py-0 right_border">
           <p class="card_heading">Lot Category</p>
           <p class="card_value">{{ lot_details && lot_details.lot_category ? lot_details.lot_category : '-' }}</p>
         </v-col>
         <v-col cols="2" class="py-0 right_border">
           <p class="card_heading">Location</p>
           <p class="card_value">{{ lot_details && lot_details.location ? lot_details.location : '-' }}</p>
         </v-col>
         <v-col cols="2" class="py-0 text-left">
           <p class="card_heading">Quantity</p>
           <p class="card_value">{{ lot_details && lot_details.quantity ? lot_details.quantity : '-' }}</p>
         </v-col>
       </v-row>
      </v-card>
    </div>
    <v-card v-if="active_tab == 'Publish Info'" class="pa-4 mt-0">
     <div class="heading mt-5">Lot Price Details</div>
     <v-row class="mx-2">
       <v-col cols="3" class="text-left">
         <p class="publish_sub_heading">Floor Price</p>
         <p class="publish_sub_value">{{ lot_details.floor_price ? `₹ ${lot_details.floor_price.toLocaleString('en-IN')}` : '-' }}</p>
       </v-col>
       <v-col cols="3" class="text-left">
         <p class="publish_sub_heading">Increamental Bid</p>
         <p class="publish_sub_value">{{ lot_details.bid_value_multiple_of ? `₹ ${lot_details.bid_value_multiple_of.toLocaleString('en-IN')}` : '-' }}</p>
       </v-col>
       <v-col cols="3" class="text-left">
         <p class="publish_sub_heading">Reserve Price</p>
         <p class="publish_sub_value">{{ lot_details.reserve_price ? `₹ ${lot_details.reserve_price.toLocaleString('en-IN')}` : '-' }}</p>
       </v-col>
       <v-col cols="3" class="text-left">
         <p class="publish_sub_heading">Buy Now Price</p>
         <p class="publish_sub_value">{{ lot_details.buy_now_price ? `₹ ${lot_details.buy_now_price.toLocaleString('en-IN')}` : '-' }}</p>
       </v-col>
     </v-row>
     <div class="heading mt-5">Lot timeline</div>
     <v-row class="mx-2">
       <v-col cols="3" class="text-left">
         <p class="publish_sub_heading">Start Date & Time</p>
         <p class="publish_sub_value">{{ lot_details.start_date ? lot_details.start_date : '-' }}</p>
       </v-col>
       <v-col cols="3" class="text-left">
         <p class="publish_sub_heading">End Date & Time</p>
         <p class="publish_sub_value">{{ lot_details.end_date ? lot_details.end_date : '-' }}</p>
       </v-col>
       <v-col cols="3" class="text-left">
         <p class="publish_sub_heading">Delivery Timeline</p>
         <p class="publish_sub_value">{{ lot_details.delivery_timeline ? `${lot_details.delivery_timeline} Days` : '-' }}</p>
       </v-col>
       <v-col cols="3" class="text-left">
         <p class="publish_sub_heading">No. of unique bids</p>
         <p class="publish_sub_value">{{ lot_details.uniq_bids_no ? lot_details.uniq_bids_no : '-' }}</p>
       </v-col>
     </v-row>
     <div class="heading mt-5">Lot Media</div>
     <v-row class="mx-2">
       <v-col cols="3" class="text-left">
         <p class="publish_sub_heading">Images</p>
         <p class="view_css" :class="(lot_details && lot_details.lot_image_urls && lot_details.lot_image_urls.length == 0) ? 'disabled_class' : ''" @click="openDialog">View</p>
       </v-col>
       <v-col cols="3" class="text-left">
         <p class="publish_sub_heading">Videos</p>
         <p class="view_css disabled_class">View</p>
       </v-col>
       <v-col cols="3" class="text-left" v-if="router_text == 'Pending B2B Publish'">
         <p class="publish_sub_heading">Lot</p>
         <p class="view_css" :class="currentUser == 'management' ? 'disabled_class' : ''" @click="navigateeditinventorydilogToComponent">Edit Lot Details</p>
       </v-col>
        <v-col cols="3" class="text-left" v-if="lot_details.lot_type === 'RFQ Lot'">
         <p class="publish_sub_heading">RFQ Manifest</p>
         <p class="view_css" :class="currentUser == 'management' ? 'disabled_class' : ''" @click="downloadManifestFile">Download</p>
       </v-col>
     </v-row>
    </v-card>
    <v-card v-if="active_tab == 'Inventory List'" class="inventory_list mt-0">
      <v-card-title class="action-style pb-0">
        <v-row class="ma-4 mb-1">
        <v-text-field prepend-inner-icon="mdi-magnify"  v-model="search" label="Search" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
         <v-spacer></v-spacer> 
         <!-- action buttons -->
         <v-actions style="margin-bottom: 28px;">
           <v-btn class="mr-2 text-none" size="x-large" variant="flat" color="primary" :disabled="selected == 0 || currentUser == 'management'" v-if="tab_action == 'Pending B2B Publish' && lot_details.lot_type != 'RFQ Lot'" @click="inventory_delete_popup = true">Delete</v-btn>
         </v-actions>
         <v-expansion-panels class="custom-control_outlined" ref="filterPopupRef" readonly style="max-width: 110px; margin-bottom: 28px; min-height: 52px;">
          <v-expansion-panel variant="outlined">
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
            </v-expansion-panel>
          </v-expansion-panels>
       </v-row>
     </v-card-title>
     <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table
         :dense="true" 
         v-model="selected"
         show-select
         disable-pagination 
         :hide-default-footer="true"
         :headers="headers" 
         :items="table_data" 
         :items-per-page="pageSize"
         :loading="loading"
         fixed-header
         height="100%"
         return-object 
         loading-text="Loading Data... Please wait"
         class="elevation-1">  
           <template v-slot:[`item.item_type`]="{item}">
             <span>{{ item.item_type ? item.item_type : "-"}}</span>
           </template> 
           <template v-slot:[`item.serial_number`]="{item}">
             <span>{{ item.serial_number ? item.serial_number : "-"}}</span>
           </template>
           <template v-slot:[`item.grade`]="{item}">
             <span>{{ item.grade ? item.grade : "-"}}</span>
           </template>
           <template v-slot:[`item.price`]="{item}">
             <span>{{ item.price ? formatCurrency(item.price) : "-"}}</span>
           </template>
           <template v-slot:[`item.inventory_status`]="{item}">
             <span>{{ item.inventory_status ? item.inventory_status : "-"}}</span>
           </template>
           <template v-slot:[`item.is_active`]="{item}">
             <span>{{ item.is_active === true ? "No" : "Yes"}}</span>
           </template>
           <template #bottom></template>
         </v-data-table>
       </v-col>
     </v-layout>
     <!-- <div>
       <v-row class="ml-2 pb-0">
         <v-col cols="4" sm="1" class="PaddingItemPerPage">
           <v-select v-model="pageSize" :items="pageSizes" label="Items per page" @change="handlePageSizeChange"></v-select>
         </v-col>
         <v-spacer></v-spacer>
         <v-col cols="12" sm="4" class="PaddingItemPerPage">
           <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
         </v-col>
       </v-row>
     </div> -->
           <div>
              <v-row class="ml-2 my-2 pb-4">
                  <span class="PaddingItemPerPage d-flex mt-4">
                      <label class="" style="margin-top: -2px;">Rows Per Page</label>
                      <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
                      variant="outlined" density="compact" style="margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
                  </span>
                  <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
                      v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
                  <v-spacer></v-spacer>
                  <div class="d-flex">
                      <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
                      - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
                      <span class="PaddingItemPerPage mr-3" :style="totalPages>7 ? 'min-width: 380px' : 'auto'">
                      <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
                      @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
                      </span>
                  </div>
              </v-row>
          </div>
    </v-card>
    <v-card v-if="active_tab == 'Bid Details'" class="pa-4 bid_inventory mt-0">
     <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table
           :dense="true"  
           disable-pagination 
           :hide-default-footer="true"
           :headers="bid_headers" 
           :items="bid_table_data" 
           :loading="loading"
           fixed-header
           height="100%" 
           v-model="selected"
           return-object
           loading-text="Loading Data... Please wait"
           class="elevation-1">
            <template v-slot:item.created_at="{item}">
                    <span style="display: flex;">
                      {{ item.created_at }}
                      <v-spacer></v-spacer>
                      <span @click="toggleExpand(item)" v-if="isDuplicate(item)">
                        <v-icon color="primary" v-if="!item.is_expanded">mdi-chevron-down</v-icon>
                        <v-icon color="primary" v-else>mdi-chevron-up</v-icon>
                      </span>
                    </span>
            </template>
            <template v-slot:item.bid_price="{item}">
             <span>{{ item.bid_price ? "₹"+formatCurrency(item.bid_price) : "-"}}</span>
           </template>
           <template v-slot:item.remarks="{item}">
             <span>{{ item.remarks ? item.remarks : "-"}}</span>
           </template>
           <template #bottom></template>
         </v-data-table>
       </v-col>
     </v-layout>
          <div>
              <v-row class="ml-2 my-2 pb-4">
                  <span class="PaddingItemPerPage d-flex mt-4">
                      <label class="" style="margin-top: -2px;">Rows Per Page</label>
                      <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
                      variant="outlined" density="compact" style="margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
                  </span>
                  <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
                      v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
                  <v-spacer></v-spacer>
                  <div class="d-flex">
                      <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
                      - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
                      <span class="PaddingItemPerPage mr-3" :style="totalPages>7 ? 'min-width: 380px' : 'auto'">
                      <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
                      @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
                      </span>
                  </div>
              </v-row>
          </div>
     <!-- <div>
       <v-row class="ml-2 pb-0">
         <v-col cols="4" sm="1" class="PaddingItemPerPage">
           <v-select v-model="pageSize" :items="pageSizes" label="Items per page"></v-select>
         </v-col>
         <v-spacer></v-spacer>
         <v-col cols="12" sm="4" class="PaddingItemPerPage">
           <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right" prev-icon="mdi-menu-left"></v-pagination>
         </v-col>
       </v-row>
     </div> -->
    </v-card>

    <v-card v-if="active_tab == 'User Feedback'" class="pa-4">
     <v-row>
       <v-col class="mr-2" :class="selected_user.includes('Lot Too Large') ? 'selected_user_feedback' : ''" @click="update_user_feedback('Lot Too Large')">
         <div class="d-flex">
           <div class="user_feedback_heading mb-4" :class="selected_user.includes('Lot Too Large') ? '' : 'grey_color'" :style="selected_user.includes('Lot Too Large') ? 'width: calc(100% - 20px)' : ''">Lot Too Large</div>
           <v-icon v-if="selected_user.includes('Lot Too Large')" class="user_feedback_close">mdi-close-circle</v-icon>
         </div>
         <!-- <p class="number_of_buyer_css">No. of Buyers</p> -->
         <p class="buyers_value_css">{{ too_large_buyer < 10 ? String(too_large_buyer).padStart(2, '0') : too_large_buyer }}</p>
       </v-col>
       <v-col class="mr-2" :class="selected_user.includes('Lot Too Small') ? 'selected_user_feedback' : ''" @click="update_user_feedback('Lot Too Small')">
         <div class="d-flex">
           <div class="user_feedback_heading mb-4" :class="selected_user.includes('Lot Too Small') ? '' : 'grey_color'" :style="selected_user.includes('Lot Too Small') ? 'width: calc(100% - 20px)' : ''">Lot Too Small</div>
           <v-icon v-if="selected_user.includes('Lot Too Small')" class="user_feedback_close">mdi-close-circle</v-icon>
         </div>
         <!-- <p class="number_of_buyer_css">No. of Buyers</p> -->
         <p class="buyers_value_css">{{ too_small_buyer < 10 ? String(too_small_buyer).padStart(2, '0') : too_small_buyer }}</p>
       </v-col>
       <v-col class="mr-2" :class="selected_user.includes('Logistics Cost Is Too High') ? 'selected_user_feedback' : ''" @click="update_user_feedback('Logistics Cost Is Too High')">
         <div class="d-flex">
           <div class="user_feedback_heading mb-4" :class="selected_user.includes('Logistics Cost Is Too High') ? '' : 'grey_color'" :style="selected_user.includes('Logistics Cost Is Too High') ? 'width: calc(100% - 20px)' : ''">Logistics Cost Is Too High</div>
           <v-icon v-if="selected_user.includes('Logistics Cost Is Too High')" class="user_feedback_close">mdi-close-circle</v-icon>
         </div>
         <!-- <p class="number_of_buyer_css">No. of Buyers</p> -->
         <p class="buyers_value_css">{{ logis_too_high_buyer < 10 ? String(logis_too_high_buyer).padStart(2, '0') : logis_too_high_buyer }}</p>
       </v-col>
       <v-col class="mr-2" :class="selected_user.includes('Lot Mixed Not Good') ? 'selected_user_feedback' : ''" @click="update_user_feedback('Lot Mixed Not Good')">
         <div class="d-flex">
           <div class="user_feedback_heading mb-4"  :class="selected_user.includes('Lot Mixed Not Good') ? '' : 'grey_color'" :style="selected_user.includes('Lot Mixed Not Good') ? 'width: calc(100% - 20px)' : ''">Lot Mixed Not Good</div>
           <v-icon v-if="selected_user.includes('Lot Mixed Not Good')" class="user_feedback_close">mdi-close-circle</v-icon>
         </div>
         <!-- <p class="number_of_buyer_css">No. of Buyers</p> -->
         <p class="buyers_value_css">{{ mixed_not_good_buyer < 10 ? String(mixed_not_good_buyer).padStart(2, '0') : mixed_not_good_buyer }}</p>
       </v-col>
       <v-col class="mr-2" :class="selected_user.includes('Manifest Not Clear') ? 'selected_user_feedback' : ''" @click="update_user_feedback('Manifest Not Clear')">
         <div class="d-flex">
           <div class="user_feedback_heading mb-4" :class="selected_user.includes('Manifest Not Clear') ? '' : 'grey_color'" :style="selected_user.includes('Manifest Not Clear') ? 'width: calc(100% - 20px)' : ''">Manifest Not Clear</div>
           <v-icon v-if="selected_user.includes('Manifest Not Clear')" class="user_feedback_close">mdi-close-circle</v-icon>
         </div>
         <!-- <p class="number_of_buyer_css">No. of Buyers</p> -->
         <p class="buyers_value_css">{{ manifest_not_clear_buyer < 10 ? String(manifest_not_clear_buyer).padStart(2, '0') : manifest_not_clear_buyer }}</p>
       </v-col>
       <v-col class="mr-2" :class="selected_user.includes('No Grading Details') ? 'selected_user_feedback' : ''" @click="update_user_feedback('No Grading Details')">
         <div class="d-flex">
           <div class="user_feedback_heading mb-4"  :class="selected_user.includes('No Grading Details') ? '' : 'grey_color'" :style="selected_user.includes('No Grading Details') ? 'width: calc(100% - 20px)' : ''">No Grading Details</div>
           <v-icon v-if="selected_user.includes('No Grading Details')" class="user_feedback_close">mdi-close-circle</v-icon>
         </div>
         <!-- <p class="number_of_buyer_css">No. of Buyers</p> -->
         <p class="buyers_value_css">{{ no_grading_buyer  < 10 ? String(no_grading_buyer ).padStart(2, '0') : no_grading_buyer  }}</p>
       </v-col>
       <v-col class="mr-2" :class="selected_user.includes('Price Not Attractive') ? 'selected_user_feedback' : ''" @click="update_user_feedback('Price Not Attractive')">
         <div class="d-flex">
           <div class="user_feedback_heading mb-4"  :class="selected_user.includes('Price Not Attractive') ? '' : 'grey_color'" :style="selected_user.includes('Price Not Attractive') ? 'width: calc(100% - 20px)' : ''">Price Not Attractive</div>
           <v-icon v-if="selected_user.includes('Price Not Attractive')" class="user_feedback_close">mdi-close-circle</v-icon>
         </div>
         <!-- <p class="number_of_buyer_css">No. of Buyers</p> -->
         <p class="buyers_value_css">{{ price_not_att_buyer  < 10 ? String(price_not_att_buyer ).padStart(2, '0') : price_not_att_buyer }}</p>
       </v-col>
     </v-row>
    </v-card>
    <v-card v-if="active_tab == 'User Feedback'" class="user_feedbackui mt-0">
    <v-card-title class="action-style pb-0">
        <v-row class="ma-4 mb-1">
       <v-text-field v-model="search" variant="outlined" label="Search" prepend-inner-icon="mdi-magnify" style="max-width: 300px;" v-on:keyup.enter="getUserFeedbackDetails"/>
      </v-row>
     </v-card-title>
      <v-layout column>
       <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table
          :dense="true" 
          disable-pagination 
          :hide-default-footer="true"
          :headers="user_headers" 
          :items="user_table_data" 
          :loading="loading"
          fixed-header
          return-object
          height="100%" 
          loading-text="Loading Data... Please wait"
          class="elevation-1">
         <template #[`item.buyer_id`]="{ item }">
           <a @click="navigateToBuyerDetails(item)" style="color: #1976d2; cursor: pointer;">
               <u>{{ item.buyer_id }}</u>
             </a>
         </template>
         <template #bottom></template>
       </v-data-table>
      </v-col>
    </v-layout>
       <div>
          <v-row class="ml-2 my-2 pb-4">
              <span class="PaddingItemPerPage d-flex mt-4">
                  <label class="" style="margin-top: -2px;">Rows Per Page</label>
                  <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
                  variant="outlined" density="compact" style="margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
              </span>
              <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
                  v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
              <v-spacer></v-spacer>
              <div class="d-flex">
                  <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
                  - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
                  <span class="PaddingItemPerPage mr-3" :style="totalPages>7 ? 'min-width: 380px' : 'auto'">
                  <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
                  @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
                  </span>
              </div>
          </v-row>
        </div>
     </v-card>

     <!-- Uploaded documents -->
     <v-card v-if="active_tab == 'Uploaded Documents' || active_tab == 'Approval History'" class="mt-0">
      <v-card-title class="action-style pb-0">
        <v-row class="ma-4 mb-0">
           <v-text-field v-model="search" v-if="active_tab == 'Approval History'" variant="outlined" label="Search" @v-on:keyup.enter="getdataApprovalHistory" prepend-inner-icon="mdi-magnify" style="max-width: 300px;"/>
       </v-row>
     <!-- action buttons -->   
     <v-spacer></v-spacer> 
     <v-actions style="margin-bottom: 20px; display:flex; justify-content: right;">
       <v-btn class="ma-2 text-none" size="x-large" variant="flat"  color="primary" v-if="tab_action !== 'Closed' && active_tab === 'Uploaded Documents'" style="color: #FFFFFF;" @click="uploadDocOpenPopup" :disabled="currentUser == 'management'">Upload New Document</v-btn>
       <!-- <v-btn class="ma-2 text-none" x-large color="primary" style="color: #FFFFFF;" @click="">Sort by</v-btn> -->
     </v-actions>
    </v-card-title>
       <v-layout column>
        <v-col cols="12" style="overflow: auto" class="p-0">
          <v-data-table
           :dense="true"
           v-model="selected" 
           disable-pagination 
           show-select
           :headers="uploaded_headers" 
           :items="formattedUploadedData" 
           :loading="loading"
           fixed-header
           return-object
           height="90%" 
           loading-text="Loading Data... Please wait"
           class="elevation-1 custom-data-table">
             <template #[`item.preview`]="{ item }">
                 <a @click="complianceImageShow(item)" style="color: #1976d2; cursor: pointer;"><u>Preview</u></a>
             </template>
             <template #[`item.download_Doc`]="{ item }">
               <v-icon color="primary" @click="downloaddoc(item)" style="cursor: pointer;">mdi-download</v-icon>
             </template>
             <!-- <template #[`item.file_history`]="{ item }">
                 <a @click="filehistory(item)" style="color: #1976d2; cursor: pointer;"><u>View</u></a>
             </template> -->
             <template #[`item.edit`]="{ item }">
               <v-icon color="primary" @click="uploadDocOpenPopup(item)" style="cursor: pointer;">mdi-pencil-outline</v-icon>
             </template>
             <template v-slot:item.comments="{item}">
             <span>{{ item.comments ? item.comments : "-" }}</span>
           </template>
            <template v-slot:item.approval_decision="{item}">
              <span>{{ item.approval_decision ? capitalize(item.approval_decision) : "-" }}</span>
            </template>
           <!-- <template #bottom></template> -->
         </v-data-table>
     </v-col>
   </v-layout>
       <!-- <div>
          <v-row class="ml-2 my-2 pb-4">
              <span class="PaddingItemPerPage d-flex mt-4">
                  <label class="" style="margin-top: -2px;">Rows Per Page</label>
                  <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
                  variant="outlined" density="compact" style="margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
              </span>
              <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
                  v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
              <v-spacer></v-spacer>
              <div class="d-flex">
                  <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
                  - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
                  <span class="PaddingItemPerPage mr-3" :style="totalPages>7 ? 'min-width: 380px' : 'auto'">
                  <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
                  @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
                  </span>
              </div>
          </v-row>
        </div> -->
 </v-card>

     <!-- Image show popup -->
   <v-dialog v-model="dialogVisible" persistent max-width="600">
     <v-card class="v-card-100">
       <v-card-title>
         <v-row  class="ma-1">
           <v-spacer></v-spacer>
           <v-tabs class="images_videos_tab d-flex justify-center" hide-slider style="align-items: center; border-radius: 56px; width: 90%;">
             <v-tab class="text-none px-6" style="background: #0357D033; border-radius: 56px; color: black;"><v-icon class="mr-1">mdi-image-multiple-outline</v-icon> Images</v-tab>
             <v-tab class="text-none px-6" disabled><v-icon class="mr-1">mdi-play-box-multiple-outline</v-icon> Videos</v-tab>
           </v-tabs>
           <v-spacer></v-spacer>
           <!-- <v-btn icon @click="dialogVisible = false"> -->
            <v-icon @click="dialogVisible = false">mdi-close</v-icon>
          <!-- </v-btn> -->
         </v-row>
       </v-card-title>
       
       <v-card-text>
         <v-row v-if="lot_details && lot_details.lot_image_urls && lot_details.lot_image_urls.length">
         <!-- <div id="demo" class="carousel slide" data-ride="carousel">

           <ul class="carousel-indicators d-flex" ref="indicatorList" :class="(lot_details && lot_details.lot_image_urls && lot_details.lot_image_urls.length > 18) ? 'justify-content-start' : ''" style="width: 400px!important;overflow: auto !important;">
             <li v-for="(imageUrl, index) in lot_details.lot_image_urls" 
                 :key="index"
                 :data-slide-to="index"
                 :class="{ active: index === 0 }">
                 <v-icon>mdi-small-circle</v-icon>
             </li>
           </ul>

           <div class="carousel-inner d-flex" style="height: 500px; align-items: center;width: 585px;">
             <div v-for="(imageUrl, index) in lot_details.lot_image_urls" 
                 :key="index" 
                 :class="['carousel-item', { active: index === 0 }]">
               <img :src="imageUrl" class="d-block justify-content-center" alt="Carousel image" style="width: 400px;margin-left: 90px;max-height: 400px;">
             </div>
           </div>

           <a class="carousel-control-prev" href="#demo" role="button" data-slide="prev" @click="prevSlide">
             <v-icon style="font-size: 60px;color: #0357D0;position: relative;left:-8px;">mdi-chevron-left</v-icon>
           </a>
           <a class="carousel-control-next" href="#demo" role="button" data-slide="next" @click="nextSlide">
             <v-icon style="font-size: 60px;color: #0357D0;position: relative;">mdi-chevron-right</v-icon>
           </a>
         </div> -->
         <div class="carousel-container">
            <v-carousel
              v-model="activeIndex"
              style="height: 450px; background: white !important; align-items: center; width: 585px;"
            >
              <v-carousel-item
                v-for="(imageUrl, index) in lot_details.lot_image_urls"
                :key="index"
                :src="imageUrl"
                cover
                height="450"
              ></v-carousel-item>
            </v-carousel>
          </div>
         </v-row>
       </v-card-text>
     </v-card>
   </v-dialog>
   <v-row justify="center">
     <v-dialog v-model="inventory_delete_popup" persistent max-width="450px">
       <v-card class="v-card-100">
         <v-card-title>
           <v-spacer />
           <v-icon @click="inventory_delete_popup = false">mdi-close</v-icon>             
         </v-card-title>
         <v-card-text class="pt-4">
           <v-container>
             <div class="text-center">
               Are you sure you want to delete the {{ selected.length }} Items?
             </div>
           </v-container>
         </v-card-text>
         <v-card-actions class="pb-4">
           <v-spacer></v-spacer>
           <v-btn large text color="primary" variant="outlined" class="text-none" style="border: 1px solid;" @click="inventory_delete_popup = false">Cancel</v-btn>
           <v-btn large color="primary"  variant="flat" class="text-none" @click="deleteInventory">Confirm</v-btn>
           <v-spacer />
         </v-card-actions>
       </v-card>
     </v-dialog>
   </v-row>
   <!-- Uplpad Documents popup -->
   <v-row justify="center">
     <v-dialog v-model="upload_documents" persistent max-width="364px">
       <v-card class="v-card-100">
         <v-card class="v-card-100">
           <v-card-title>
            <v-row class="ma-1">  
             <span>Upload Documents</span>
             <v-spacer></v-spacer>
             <!-- <v-btn icon @click="upload_documents = false"> -->
               <v-icon @click="upload_documents = false">mdi-close</v-icon>
             <!-- </v-btn> -->
              </v-row>
           </v-card-title>
         </v-card>
         <v-card-text class="download-email">
           <v-row style="display: inline;">
             <v-combobox v-model="select_documents" :items="select_documents_items" label="Select Documents" variant="outlined"
               type="text" hide-details class="mb-5" :disabled="disabled_select_doc"></v-combobox>
             <v-file-input 
                v-model="file_compliance" 
               accept="csv" 
               @update:modelValue="changeFile" 
               class="mb-5 mt-10"
               variant="outlined" 
               prepend-inner-icon="mdi-paperclip" 
               prepend-icon="" 
               label="Attach pdf/jpg/ file"
               :error="fileError"
               :error-messages="fileErrorMessage"
               >
             </v-file-input>
             <div v-if="fileName" style="margin: -20px 10px 0px 0px;"><v-chip class="ma-2" close
                 @click:close="closeChip">
                 {{ fileName }}
               </v-chip></div>
             <div v-if="uploading">
               Uploading file ({{ uploadPercentage }}%)
               <v-progress-linear :value="uploadPercentage" color="blue" height="10"></v-progress-linear>
             </div>
             <div v-if="completed">
               <v-progress-linear :value="uploadPercentage" color="blue" height="10"></v-progress-linear>
               <p style="color:green;text-align: right;">Completed</p>
             </div>
             <v-row v-if="file_data">
               <v-col v-for="(file, index) in file_data" :key="index" cols='2' sm="6" md="6" class="p-0">
                 <v-chip class="mt-1 ml-4" close @click:close="removeFile(file.document_name, index)">
                   <span v-if="file.document_name && file.document_name.length > 10">{{ file.document_name.slice(0, 10) }}...</span>
                   <span v-else>{{ file.document_name}}</span>
                 </v-chip>
               </v-col>
             </v-row>
           </v-row>
         </v-card-text>
         <v-card-actions center>
           <v-spacer></v-spacer>
           <!-- <v-btn small class="text-none" outlined large color="primary" @click="upload_documents = false">Cancel</v-btn> -->
           <v-btn color="primary" class="mb-3 text-none" variant="outlined" v-if="this.confirmButton != 'FINISH'" @click="confirmUploadFile" :disabled="!file_compliance || number > 0 || fileError">Confirm</v-btn>
           <v-btn color="primary" class="mb-3 text-none" variant="flat" v-if="this.confirmButton == 'FINISH'" @click="clickFinish">Finish</v-btn>
           <v-spacer></v-spacer>
         </v-card-actions>
       </v-card>
     </v-dialog>
   </v-row>
  <!-- Compliance image show popup -->
  <v-dialog v-model="complaince_image_show" persistent max-width="600">
     <v-card class="v-card-100">
       <v-card-title>
        <v-row class="ma-1">
         <!-- <span class="headline">Images</span> -->
         <v-spacer></v-spacer>
         <!-- <v-btn icon @click="complaince_image_show = false"> -->
           <v-icon @click="complaince_image_show = false">mdi-close</v-icon>
         <!-- </v-btn> -->
          </v-row>
       </v-card-title>
       
       <v-card-text>
         <v-row>
           <v-col>
             <v-img v-if="!isPdf" :src="imageUrls" width="100%" contain></v-img>
             <iframe v-if="isPdf" :src="pdfViewerUrl" style="width:100%; height:500px;" frameborder="0"></iframe>
           </v-col>
         </v-row>
       </v-card-text>
     </v-card>
   </v-dialog>
 </div>
</template>
<script>
 import HeaderComponent from "./../../../../commoncomponents/HeaderComponent";
 import $ from "jquery";
 import Loading from 'vue-loading-overlay';
//  import 'vue-loading-overlay/dist/vue-loading.css';

 export default {
   components: {
     HeaderComponent,Loading
   },
   data(){
     return {
        headerText: "Liquidation",
        alert_message : '',
        alert_type : 'success',
        alert : false,
        router_text : '',
        compo_name : '',
        tabs : ["Publish Info","Inventory List","Bid Details","User Feedback","Uploaded Documents","Approval History"],
        active_tab : 'Publish Info',
        search : '',
        headers : [
         { title: "Tag ID", key: "tag_number"},
         { title: "Item Type", key: "item_type"},
         { title: "SKU", key: "sku_code"},
         { title: "Serial Number", key: "serial_number"},
         { title: "Grade", key: "grade"},
         { title: "Price (₹)", key: "price"}
        ],
        uploaded_headers :[
         { title: "Document Type", key: "document_name"},
         { title: "File Name", key: "document_name"},
         { title: "Uploaded on", key: "created_on"},
         { title: "Modified on", key: "modified_on"},
         { title: "Uploaded by", key: "uploaded_by"},
         { title: "Preview", key: "preview"},
         { title: "Download Doc", key: "download_Doc"},
         // { title: "File history", key: "file_history"},
         { title: "Edit", key: "edit"}
        ],
        uploaded_data: [],
       //  bid_headers : [
       //     { title: "Buyer", key: "user_name"},
       //     { title: "Client IP", key: "buyer_ip"},
       //     { title: "Bid Price", key: "higest_bid"},
       //     { title: "Created At", key: "create_date"}
       //  ],
        expanded: [],
        bid_headers: [],
        table_data : [],
        bid_table_data : [],
        pageSize : 15,
        pageSizes : [15,30,60],
        totalPages : 8,
        page : 1,
        totalCount : 0,
        lot_details : {},
        dialogVisible : false,
        tab_action : '',
        selected_user : [],
        too_large_buyer : '',
        too_small_buyer : '',
        logis_too_high_buyer : '',
        mixed_not_good_buyer  : '',
        manifest_not_clear_buyer : '',
        no_grading_buyer : '',
        price_not_att_buyer : '',
        loading : false,
        user_headers : [
           { title: "Buyer ID", key: "buyer_id"},
           { title: "Feedback", key: "feedback"},
           { title: "Remarks", key: "remark"}
        ],
        user_table_data: [],
        selected : [],
        inventory_delete_popup : false,
        isLoading : false,
        fullPage : true,
        primary_code : '#0275d8',
        activeIndex : 0,
        totalCount : 0,
        complaince_image_show:false,
        upload_documents: false,
        disabled_select_doc: false,
        select_documents: null,
        select_documents_items: [],
        uploadPercentage: 0,
        upload_file: '',
        uploading: false,
        completed: false,
        confirmButton: 'CONFIRM',
        file_compliance: '',
        file_url: '',
        fileName: '',
        fileDate: '',
        file_data: [],
        add_weight_kg:'',
        add_weight:false,
        upload_doc_view:'',
        fileErrorMessage:'',
        fileError: false,
        currentUser:'',
        item_id:'',
        closed_report:'',
        isPdf: false,
        pdfViewerUrl: '',
        imageUrls:'',
        apprval_hist_headers:[],
        approval_hist_data:[]
     }
   },
   created(){
     this.compo_name = `Publish ID(${this.$store.state.lot})`
     this.tab_action = this.$store.state.action
     this.currentUser = this.$store.state.currentUser.roles[0]
     if(this.tab_action === 'Pending Approval'){
      this.item_id = this.$store.state.lot; 
     }else{
      this.item_id = this.$store.state.lot;
     }
         
     if(this.tab_action == 'edit_lot' || this.tab_action == 'edit_lot_rfq')
       this.tab_action = 'Pending B2B Publish'
     this.router_text = this.tab_action == 'In Progress B2B' ? 'In Progress (B2b Publish)' : this.tab_action 
     if(this.tab_action == 'Pending B2B Publish' || (!this.$store.state.currentUser.roles.includes('client_admin') && !this.$store.state.currentUser.roles.includes('admin')))
       this.tabs =["Publish Info","Inventory List"] 
     else this.tabs = ["Publish Info","Inventory List","Bid Details","User Feedback", "Uploaded Documents","Approval History"]
     this.loadData('Publish Info')
   },
   computed: {
    // groupedBidData() {
    //   const result = this.bid_table_data.map((bidArray) => {
    //   const sortedBids = bidArray.sort((a, b) => b.bid_price - a.bid_price);
    //     return {
    //       user_name: sortedBids[0].buyer,
    //       buyer_ip: sortedBids[0].client_ip,
    //       highestBid: {
    //         bid_price: sortedBids[0].bid_price,
    //         create_date: sortedBids[0].created_at,
    //       },
    //       otherBids: sortedBids.slice(1).map((bid) => ({
    //         buyer_ip: bid.client_ip,
    //         bid_price: bid.bid_price,
    //         create_date: bid.created_at,
    //       })),
    //     };
    //   });
    //   return result;
    // },
     formattedUploadedData() {
      if (!this.uploaded_data) {
        return [];
      }
      return this.uploaded_data.map((item) => ({
        ...item,
        created_on: this.formatToIST(item.created_on),
        modified_on: this.formatToIST(item.modified_on),
      }));
    },
   formatted_table_currency(){
     return this.table_data.map((item) => {
        const formatItem = { ...item };
        this.headers.forEach((header) => {
         if(header.title.includes("₹")){
           formatItem[header.key] = this.formatCurrency(item[header.key]);
         }
        });
        return formatItem;
     })
   },
   },
   methods: {
    isDuplicate(item) {
          return !item.is_crm_duplicate && this.crm_ticket_dupl_details[item.buyer]&& this.crm_ticket_dupl_details[item.buyer].length
      },
      toggleExpand(data) {
          const index = this.bid_table_data.findIndex(item => item.buyer === data.buyer);
          console.log("Index found:", index);
          if (index > -1) {
            data.is_expanded = !data.is_expanded;
            if (data.is_expanded) {
              this.bid_table_data.splice(index + 1, 0, ...this.crm_ticket_dupl_details[data.buyer]);
            } else {
              this.bid_table_data.splice(index + 1, this.crm_ticket_dupl_details[data.buyer].length);
            }
          }
          },
     formatCurrency(value){
     return Number(value).toLocaleString('en-IN');
   },
     showAlert(alert_type, alert_message) {
       this.alert = true;
       this.alert_type = alert_type;
       this.alert_message = alert_message;
       this.alertTimeOut();
     },
     alertTimeOut() {
       setTimeout(() => {
         this.alert = false;
       }, 3000);
     },
     loadData(tab,tab_action){
       this.active_tab = tab;
       if(tab_action)
         this.search = ''
       if(tab === 'Publish Info'){this.getLotDetails();}
       else if(tab === 'Inventory List')
         {this.getInventoryDetails();}
       else if(tab === 'Bid Details')
         { 
          this.bid_headers= [
         { title: "Buyer", key: "buyer", width:"360px"},
         { title: "Client IP", key: "client_ip", width:"360px"},
         { title: "Bid Price", key: "bid_price", width:"230px"},
         { title: "Created At", key: "created_at", width:"360px" },
         { title: "Reason", key: "remarks", width:"100px" },
       ],
          this.getBidDetails();
        }
       else if(tab === 'User Feedback')
         {this.getUserFeedbackDetails()}
       else if(tab === 'Uploaded Documents')
       {this.getViewLotDocuments();}
       else if(tab === 'Approval History')
       {this.getdataApprovalHistory()}
     },
     getRouterLink(){
       var tabName = this.tab_action
       tabName = tabName.replace(/\s/g,'_');
       tabName = tabName.replace(/&/g,'')
       return this.tab_action !== 'Closed' ?{ name : 'liquidationNew', query: {tab : tabName, changed : true}} : { name : 'ClosedReport'}
     },
     getLotDetails(){
       this.isLoading = true
       const api = `/api/v2/warehouse/liquidation_order/b2b/pending_publish/${this.item_id}`
       this.$httpSecured.get(api)
       .then(response => {
         this.isLoading = false
         this.lot_details = response.data.liquidation_order
         if(this.lot_details.lot_type === 'RFQ Lot' && this.$store.state.currentUser.roles[0] === 'central_admin'){
           this.tabs =  ["Publish Info"];
         }else if(this.lot_details.lot_type === 'Competitive Lot' && this.$store.state.currentUser.roles[0] === 'central_admin'){
             this.tabs =  ["Publish Info","Inventory List"];
         }else if(this.lot_details.lot_type === 'RFQ Lot' && this.$store.state.currentUser.roles[0] !== 'central_admin'){
             this.tabs =  ["Publish Info","Bid Details","User Feedback","Uploaded Documents","Approval History"];
         }
       })
       .catch(error => {
           this.showAlert("error", "Something went wrong from Network" + error);
           this.isLoading = false;
       });
     },
     getInventoryDetails(){
      if(this.router_text === 'Dispatch' || this.router_text === 'Closed'){
        const check_removed = this.headers.some(item => item.title === "Removed?")
        if(!check_removed){
          this.headers.push({ title: "Removed?", key: "is_active", width:"230px" })
        }
      }
       this.loading = true
       this.selected = []
       const params = { search_text : this.search, page : this.page, per_page : this.pageSize }
       const api = `/api/v2/warehouse/liquidation_order/b2b/pending_publish/${this.item_id}/view_inventory`
       this.$httpSecured.get(api, { params })
       .then(response => {
         this.loading = false
         this.table_data = response.data.liquidations.liquidations
         this.lot_details = response.data.lot_details
         this.totalPages = response.data.meta.total_pages
         this.totalCount = response.data.meta.total_count
       })
       .catch(error => {
           this.showAlert("error", "Something went wrong from Network" + error);
           this.loading = false;
       });
     },
     openDialog() {
       this.dialogVisible = true;
     },
     getBidDetails(){
       this.loading = true
       this.$httpSecured
       // const api = "/api/v2/warehouse/liquidation_order/pending/decision/get_bidders"
       const api = "/api/v2/warehouse/liquidation_order/pending/decision/get_bid_details"
       const params = {
         'id' : this.item_id
       }
       this.crm_ticket_dupl_details = {}
       this.$httpSecured
       .get(api,{ params })
       .then(response => {
         this.loading = false
         if (response.data) {
          const bid_table_data = response.data.bids_details.flat();
          bid_table_data.sort((a, b) => b.bid_price - a.bid_price);
          this.bid_table_data = []
          bid_table_data.forEach((item,index)=>{
            if(index == 0 || item.buyer != bid_table_data[index-1].buyer){
              item.is_expanded = false
              this.bid_table_data.push(item)
              this.crm_ticket_dupl_details[item.buyer] = []
            } else {
              item.is_crm_duplicate = true
              this.crm_ticket_dupl_details[item.buyer].push(item)
            }
          })
           this.lot_details = response.data.liquidation_order_data
         } else {
           this.showAlert("error", "No Data Found");
         }
       })
       .catch(error => {
         this.loading = false
         this.showAlert("error", "Something went wrong from Network" + error);
       });
     },
     update_user_feedback(detail){
       if(!this.selected_user.includes(detail)){
         this.selected_user.push(detail)
         this.getUserFeedbackDetails()
       } else {
         const index = this.selected_user.indexOf(detail)
         if(index != -1){
           this.selected_user.splice(index,1)
           this.getUserFeedbackDetails()
         }
       }
     },
     getUserFeedbackDetails(){
       const selected_buyer =  []
       // this.selected_user.map(item =>item.split(' ').map((word, index) => index !== 0 ? word.toLowerCase() : word).join(' '))
       this.selected_user.forEach(item => {
         if(item == 'Lot Too Large') selected_buyer.push('Lot too large')
         else if(item == 'Lot Too Small') selected_buyer.push('Lot too small')
         else if(item == 'Logistics Cost Is Too High') selected_buyer.push('Logistics cost is too high')
         else if(item == 'Lot Mixed Not Good') selected_buyer.push('Lot mix not good')
         else if(item == 'Manifest Not Clear') selected_buyer.push('Manifest not clear')
         else if(item == 'No Grading Details') selected_buyer.push('No grading details')
         else if(item == 'Price Not Attractive') selected_buyer.push('Pricing not attractive')
       })
       const params = {
         'id' : this.item_id, reason : selected_buyer, buyer_ids : this.search
         , page : this.page, per_page : this.pageSize
       }
       this.loading = true
       this.$httpSecured
       .get("/api/v2/warehouse/liquidation_order/pending/decision/get_lot_feedbacks", { params })
       .then(response => {
         if (response.data) {
           this.loading = false
           this.user_table_data = response.data.feedbacks
           this.totalCount = response.data.meta.total_count
           this.totalPages = response.data.meta.total_pages
           this.lot_details = response.data.details
           response.data.details.filters.forEach(item =>{
             if(item.reason_name == 'Lot too small') this.too_small_buyer =  item.buyer_count
             else if(item.reason_name == 'Lot too large') this.too_large_buyer =  item.buyer_count
             else if(item.reason_name == 'Logistics cost is too high') this.logis_too_high_buyer =  item.buyer_count
             else if(item.reason_name == 'Lot mix not good') this.mixed_not_good_buyer =  item.buyer_count
             else if(item.reason_name == 'Manifest not clear') this.manifest_not_clear_buyer =  item.buyer_count
             else if(item.reason_name == 'No grading details') this.no_grading_buyer =  item.buyer_count
             else if(item.reason_name == 'Pricing not attractive') this.price_not_att_buyer =  item.buyer_count
           })
         } else {
           this.loading = false
           this.showAlert("error", "No Data Found");
         }
       })
       .catch(error => {
         this.loading = false
         this.showAlert("error", "Something went wrong from Network" + error);
       });
     },
     getViewLotDocuments() {
       if(this.tab_action === 'Closed'){
         this.uploaded_headers = [
         { text: "Document Type", value: "document_name"},
         { text: "File Name", value: "document_name"},
         { text: "Uploaded on", value: "created_on"},
         { text: "Modified on", value: "modified_on"},
         { text: "Uploaded by", value: "uploaded_by"},
         { text: "Preview", value: "preview"},
         { text: "Download Doc", value: "download_Doc"},
         // { text: "File history", value: "file_history"},
         // { text: "Edit", value: "edit"}
        ]
       };
     this.$httpSecured
       .post(`/api/v2/warehouse/liquidation_orders/view_lot_documents`,{
         "id":this.item_id
       })
       .then(response => {
         if (response.data) {
           this.uploaded_data = response.data.documents_list

         } else {
           this.showAlert("error", "No Data Found");
         }
       })
       .catch(error => {
         this.showAlert("error", "Something went wrong from Network" + error);
       });
   },
     handlePageSizeChange(size){
       this.pageSize = size;
       this.page = 1
       this.loadData(this.active_tab);
     },

     handlePageChange(value){
      this.page = value;
       this.loadData(this.active_tab);
     },
     navigateToBuyerDetails(value) {
       this.$store.commit("setLotIds", {
         lotIds: value.buyer_id,
         action: 'PublishDetails',
         inventoryId: value.buyer_id
       });      
       this.$router.push({ name: "DetailsOfBuyer" });
     },
     navigateeditinventorydilogToComponent() {
       this.$store.commit("setLotIds", {
         lotIds: this.item_id,
         action: this.lot_details.lot_type == 'RFQ Lot' ? 'edit_lot_rfq' : 'edit_lot'

       });
       this.$router.push({ name: 'CreateLotCompBidd', query : { action : "edit-lot" }});
     },
     deleteInventory(){
       const selectedIds = this.selected.map(item => item.tag_number)
       this.$httpSecured         
       .post(`/api/v2/warehouse/liquidation_order/b2b/pending_publish/${this.item_id}/remove_lot_items`, 
       {
         remove_tag_numbers: selectedIds
       })
       .then(response => {
         this.inventory_delete_popup = false
         if (response.status === 200) {
           this.showAlert("success", response.data.message);
           this.$router.push(this.getRouterLink())
           // this.getInventoryDetails()
         } else {
           this.showAlert("error", "Something went Wrong !!");
         }
       })
       .catch(error => {
         this.inventory_delete_popup = false
         this.showAlert("error", error.response.data.errors);
         this.number = 0;
       });
     },
    //  nextSlide() {
    //    if (this.activeIndex < this.lot_details.lot_image_urls.length - 1) {
    //      this.activeIndex++;
    //    } else {
    //      this.activeIndex = 0;
    //    }
    //    this.scrollToActiveIndicator();
    //  },
    //  prevSlide() {
    //    if (this.activeIndex > 0) {
    //      this.activeIndex--;
    //    } else {
    //      this.activeIndex = this.lot_details.lot_image_urls.length - 1;
    //    }
    //    this.scrollToActiveIndicator();
    //  },
    nextSlide() {
      this.activeIndex = (this.activeIndex + 1) % this.lot_details.lot_image_urls.length;
    },
    prevSlide() {
      this.activeIndex = (this.activeIndex - 1 + this.lot_details.lot_image_urls.length) % this.lot_details.lot_image_urls.length;
    },
     scrollToActiveIndicator() {
      this.$nextTick(() => {
        const indicatorList = this.$refs.indicatorList;
        if (!indicatorList) return;

        const activeIndicator = indicatorList.children[this.activeIndex];
        if (activeIndicator) {
          activeIndicator.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      });
        },
     downloadManifestFile() {
       const url = this.lot_details.attachment_manifest;
       if (!url) {
         this.showAlert("error", "Manifest file not available");
         return;
       }
       fetch(url)
         .then(response => response.blob())
         .then(blob => {
           const a = document.createElement('a');
           const objectUrl = URL.createObjectURL(blob);
           a.href = objectUrl;
           a.download = url.split('/').pop();
           document.body.appendChild(a);
           a.click();
           document.body.removeChild(a);
           URL.revokeObjectURL(objectUrl);
         })
         .catch(() => {
           this.showAlert("error", "Failed to download manifest file");
         });
     },
     uploadDocOpenPopup(item) {
         this.lot_ids = '';
         // this.item_weight = item.weight;
         if(item.document_name){
           this.upload_documents = true;
           this.file_compliance = null;
           this.confirmButton = 'CONFIRM';
           this.disabled_select_doc = true
           this.select_documents = item.document_name
           // this.file_compliance = { name : item.document_url.split('/').pop() }
           const fileData = {
           document_name: item.document_name,
           document_url: item.document_url
         };
         this.file_data = [fileData];
         }else{
            this.number = 0;
            this.disabled_select_doc = false
           this.upload_documents = true;
           this.skip_button = true;
           this.file_data = [];
           this.select_documents = null;
           this.file_compliance = null;
           this.confirmButton = 'CONFIRM';
           this.getComplianceDocuments();
         }
        
       },
   getComplianceDocuments() {
     this.$httpSecured
       .post(`/api/v2/warehouse/liquidation_orders/list_of_document_types`, {
         "id":this.item_id
       })
       .then(response => {
         if (response.data) {
           // this.select_documents_items = response.data.compliance_document_list;
           const uploadedDocumentNames = this.file_data.map(file => file.document_name);
           this.select_documents_items = response.data.document_types_list.filter(doc => !uploadedDocumentNames.includes(doc));

         } else {
           this.showAlert("error", "No Data Found");
         }
       })
       .catch(error => {
         this.showAlert("error", "Something went wrong from Network" + error);
       });
   },
   confirmUploadFile() {
     this.uploadFile('start')
     this.number++;
     const formData = new FormData();
     formData.append('attachment_file', this.file_compliance);
     formData.append('document_name', this.select_documents);
     var apiUrl = '/api/v2/warehouse/liquidation_orders/upload_lot_attachment';

     this.$httpSecured
       .post(apiUrl, formData)
       .then(response => {
         this.uploadFile('success')
         this.action_name = 'success_msg';
         this.message = "Successfully uploaded.";
         this.messagePopWidth = "424px";          
         let fileData = {
           document_name: response.data.attachment_file_name,
           document_url: response.data.attachment_file
         };
         if(this.disabled_select_doc === true){
         this.file_data = [fileData];
         }else{
         this.file_data.push(fileData);
         }
         
         console.log(this.file_data);
         this.select_documents_items = this.select_documents_items.filter(item => item !== this.select_documents);
         if(this.disabled_select_doc === false){
            this.select_documents = null;
         }          
         this.file_compliance = '';
       })
       .catch(error => {
         this.number = 0;
         this.showAlert("error", error.response.data.master_file);
       });
   },
  changeFile() {
     if (this.file_compliance) {
       const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
       const fileType = this.file_compliance.type;
       this.fileError = false;
       if (!allowedTypes.includes(fileType)) {
         this.fileError = true;
         this.fileErrorMessage = 'Only PDF and JPEG/PNG files are allowed.';
       } else {
         this.fileError = false;
         this.fileErrorMessage = '';
       }
     } else {
       this.confirmButton = 'CONFIRM';
     }
   },
   uploadFile(status) {
     var percentage;
     this.uploading = true;
     let reader = new FileReader();
     if (status === 'start') {
       reader.onprogress = (event) => {
         if (event.lengthComputable) {
           percentage = Math.round((event.loaded / event.total) * 50);
           this.uploadPercentage = percentage;
         }
       };
     } else if (status === 'success') {
       reader.onprogress = (event) => {
         if (event.lengthComputable) {
           percentage = Math.round((event.loaded / event.total) * 100);
           this.uploadPercentage = percentage;
           this.uploading = false;
           this.completed = true;
           this.cancel_button_hide = true;
         }
       };
     }
     reader.onloadend = (event) => {
       if (status === 'success') {
         setTimeout(() => {
           this.uploading = false;
           this.completed = false;
           this.uploadPercentage = 0;
           this.number = 0;
           this.confirmButton = 'FINISH';
         }, 2000);
       }
     };
     reader.readAsDataURL(this.file_compliance);
   },
   clickFinish() {
     this.file_compliance = '';
     this.select_documents = '';
     // this.confirmButton = 'CONFIRM';
     this.fileName = '';
     this.file_data_cond = true;
      this.saveFiles();
     // if(this.select_documents_items == ''){        
     //   this.saveFiles();
     // }
   },
   closeChip() {
     this.fileName = '';
   },
   removeFile(type, index) {
     const documentName = this.file_data[index].document_name;
     console.log(documentName)
     this.file_data.splice(index, 1);
     if (!this.select_documents_items.includes(documentName)) {
       this.select_documents_items.push(documentName);
     }
   },
   saveFiles(condi) {
      this.number++;
      let complianceDocumentHash ={}
       this.file_data.forEach(item => {
         complianceDocumentHash[item.document_name] = {
           document_url: item.document_url,
         };
       });
         
      this.$httpSecured
       .post('/api/v2/warehouse/liquidation_orders/upload_lot_documents', 
          {
           id: this.item_id,
           lot_attachment_hash: complianceDocumentHash,
         }
       )
       .then(response => {
         this.upload_documents = false;
         this.select_documents_items = ''
         this.select_documents = '';
         this.number = 0;
         this.file_data = [];
         this.successmessage = response.data.message
         this.showAlert("success", response.data.message);
         this.loadData(this.active_tab);
       })
       .catch(error => {
         this.number = 0;
         this.showAlert("error", error.response.data.error);
       });
   },
   complianceImageShow(item){
       this.complaince_image_show = true;
       this.imageUrls = item.document_url;

       const fileExtension = this.imageUrls.split('.').pop().toLowerCase();
       this.isPdf = fileExtension === 'pdf';

       if (this.isPdf) {
         this.showPdf(this.imageUrls);
       }
     },
     showPdf(pdfUrl) {
       this.pdfViewerUrl = `https://docs.google.com/gview?url=${pdfUrl}&embedded=true`;
     },
    downloaddoc(item){
     const url = item.document_url;
     fetch(url)
         .then(response => response.blob())
         .then(blob => {
           const a = document.createElement('a');
           const objectUrl = URL.createObjectURL(blob);
           a.href = objectUrl;
           a.download = url.split('/').pop();
           document.body.appendChild(a);
           a.click();
           document.body.removeChild(a);
           URL.revokeObjectURL(objectUrl);
         })
         .catch(() => {
           this.showAlert("error", "Failed to download manifest file");
         });
    },
    formatToIST(dateString) {
      if (!dateString || isNaN(new Date(dateString).getTime())) {
         // Return a placeholder or empty string if the date is invalid or missing
         return;
       }
     const options = {
       day: '2-digit',
       month: '2-digit',
       year: 'numeric',
       hour: '2-digit',
       minute: '2-digit',
       hour12: false,
       timeZone: 'Asia/Kolkata',
     };
     return new Intl.DateTimeFormat('en-GB', options).format(new Date(dateString));
   },
   getdataApprovalHistory(){
     if(this.active_tab === 'Approval History'){
         this.uploaded_headers = [
         { title: "Approver Decision", key: "approval_decision"},
         { title: "Approval Date & Time", key: "approval_date_and_time"},
         { title: "Approver By", key: "approved_by"},
         { title: "Reason", key: "reason"},
         { title: "Comment", key: "comments"},
        ];
       this.loading = true
       this.selected = []
       const params = { search_text : this.search, page : this.page, per_page : this.pageSize }
       const api = `/api/v2/warehouse/liquidation_orders/${this.item_id}/approval_histories`
       this.$httpSecured.get(api, { params })
       .then(response => {
         this.loading = false
         this.uploaded_data = response.data.approval_histories
        //  this.totalPages = response.data.meta.total_pages
        //  this.totalCount = response.data.meta.total_count
       })
       .catch(error => {
           this.showAlert("error", "Something went wrong from Network" + error);
           this.loading = false;
       });
       }
     },
      capitalize(str) {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      },
   }
 }
</script>
<style scoped>
:deep(.v-tabs .v-tabs-bar){
 background-color: transparent !important;
}
.right_border{
 border-right: 1px solid #9C9C9C;
 text-align: left;
}
.card_heading{
 color: #979797;
 font-size : 14px;
 font-weight : 400;
 margin-bottom: 6px;
}
.card_value{
 color:#646464;
 font-size : 14px;
 font-weight : 600;
}
.heading{
 background-color: #EAF4FF;
 font-size: 18px;
 font-weight: 600;
 line-height: 25.2px;
 color: #002F9E;
 padding: 10px 10px;
 text-align: left;
}
.publish_sub_heading{
 color:#2D2D2D;
 font-size: 14px;
 font-weight: 400;
 margin-bottom: 6px;
}
.publish_sub_value{
 color:#2D2D2D;
 font-size: 14px;
 font-weight: 600;
}
.view_css{
 font-size: 14px;
 font-weight: 600;
 color: #0357D0;
 text-decoration: underline;
 cursor: pointer;
}
:deep(.bid_inventory .v-data-table) {
 height: calc(var(--vh, 1vh) * 100 - 375px) !important;
}
:deep(.inventory_list .v-data-table) {
 height: calc(var(--vh, 1vh) * 100 - 453px) !important;
}
:deep(.user_feedbackui .v-data-table) {
 height: calc(var(--vh, 1vh) * 100 - 465px) !important;
}
.user_feedback_heading{
 font-size: 14px;
 font-weight: 700;
 line-height: 16.94px;
 text-align: left;
}
.grey_color{
 color: #9C9C9C;
}
.number_of_buyer_css{
 font-size: 12px;
 font-weight: 400;
 line-height: 14.52px;
 color:#9C9C9C;
 margin-bottom: 4px;
}
.selected_user_feedback{
 border: 1px solid #0357D0;
 border-radius: 8px;
}
.buyers_value_css{
 font-size: 24px;
 font-weight: 600;
 line-height: 16.94px;
 color:#0357D0;
 text-align: left;
}
.user_feedback_close{
 font-size: 20px;
 color:#0357D0; 
 margin-top: 2px;
 height:20px;
 cursor: pointer;
}
:deep(.user_table .v-data-table) {
 height: calc(var(--vh, 1vh) * 100 - 473px) !important;
}
.disabled_class{
 pointer-events: none;
 color: grey;
 cursor: not-allowed;
}
.carousel-container {
  position: relative;
  text-align: center;
}

:deep(.carousel-container .v-img__img) {
  left: 90px !important;
  width: 70% !important;
  height: 90% !important;
}

:deep(.carousel-container .v-carousel__controls) {
  background: none !important;
}

:deep(.carousel-container .v-btn--active) {
  color: #002F9E !important; 
}
:deep(.images_videos_tab .v-tabs-bar){
 background-color: #E1F1FF !important;
}

.custom-control_outlined .v-expansion-panel:before {
 box-shadow: none;
}

.custom-control_outlined button {
 min-height: 52px;
 border-width: 1px;
 border-color: rgba(0, 0, 0, .42);
 border-style: solid;
}

.custom-control_outlined button:focus {
 outline: none;
}
.v-data-table {
 height: calc(var(--vh, 1vh) * 100 - 336px) !important;
}
.td-style1 {
 padding-left: 65px;
}
.td-style2 {
 padding-left: 55px;
}
.td-style3 {
 padding: 0px;
}
@media(min-width: 1200px) and (max-width: 1500px){
 .td-style1 {
   padding-left: 40px;
 }
 .td-style2 {
   padding-left: 40px;
 }
 .td-style3 {
   padding-left: 10px;
 }
}
.custom-data-table{
 height: calc(var(--vh, 1vh) * 100 - 270px) !important;
}
:deep(.custom-data-table .v-data-table-footer){
  margin-bottom: 20px !important;
}
.v-card{
  max-width:100% !important;
}
.padded-cell {
  margin-left: -8px !important;
}
.expanded-row td {
  padding: 8px;
  border-bottom: 1px solid #ddd; 
}
.expanded-row {
  padding: 8px !important;
  border-bottom: 1px solid #ddd !important;
}
</style>